// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#topBanner {\n  height: 200px;\n\n  position: relative;\n  color: var(--grey_one);\n  font-style: normal;\n  font-weight: normal;\n}\n\n#bannerContent {\n  width: 80%;\n  position: absolute;\n  margin-left: 5%;\n  margin-top: 4%;\n}\n\n.profileBody {\n  color: var(--grey_two);\n  margin-top: 40px;\n}\n\n.clientContent {\n  margin-left: 5%;\n}\n", ""]);
// Exports
module.exports = exports;
